export default "__VITE_ASSET__DC4bJlRp__"